import React from 'react';
import {
  SkeletonAvatar,
  SkeletonButton,
  SkeletonLine,
  SkeletonPill,
} from '../../Skeleton';

const lineWidths = ['58%', '72%', '48%', '64%'];

function PersonSkeletonRow({ index, trailing = false, responsible = false }) {
  const textClassName = responsible
    ? 'member-modal__responsible-text member-modal__skeleton-text'
    : 'member-modal__info member-modal__skeleton-text';

  return (
    <li
      className={responsible ? 'member-modal__responsible-row' : 'member-modal__row'}
      aria-hidden="true"
    >
      <SkeletonAvatar size={44} />
      <div className={textClassName}>
        <SkeletonLine width={lineWidths[index % lineWidths.length]} height={14} />
        <SkeletonLine width={responsible ? '68%' : '42%'} height={11} />
        {responsible ? <SkeletonLine width="30%" height={11} /> : null}
      </div>
      {trailing ? (
        <SkeletonButton className="member-modal__skeleton-control" width={132} height={32} />
      ) : null}
    </li>
  );
}

export default function MemberListModalSkeleton({
  label = '読み込み中...',
  responsibleRows = 2,
  artistRows = 4,
  showPartScopeTabs = true,
  showArtistTrailing = true,
}) {
  return (
    <div
      className="member-modal__loading"
      role="status"
      aria-live="polite"
      aria-label={label}
      data-testid="member-list-modal-skeleton"
    >
      <section className="member-modal__section member-modal__responsible" aria-hidden="true">
        <div className="member-modal__section-title">
          <SkeletonLine width={48} height={12} />
        </div>
        <ul className="member-modal__responsible-list">
          {Array.from({ length: responsibleRows }, (_, index) => (
            <PersonSkeletonRow key={`responsible-skeleton-${index}`} index={index} responsible />
          ))}
        </ul>
      </section>

      {showPartScopeTabs ? (
        <div className="member-modal__event-part-tabs" aria-hidden="true">
          <SkeletonPill width={88} height={28} />
          <SkeletonPill width={88} height={28} />
          <SkeletonPill width={104} height={28} />
        </div>
      ) : null}

      <section className="member-modal__section" aria-hidden="true">
        <div className="member-modal__section-title">
          <SkeletonLine width={112} height={12} />
        </div>
        <ul className="member-modal__list">
          {Array.from({ length: artistRows }, (_, index) => (
            <PersonSkeletonRow
              key={`artist-skeleton-${index}`}
              index={index}
              trailing={showArtistTrailing}
            />
          ))}
        </ul>
      </section>
    </div>
  );
}
